import { AbstractSpaceClass } from '../../../../../models/space/abstract-space.class';
import { EntitySPSpaces } from './details-overlay.model';

export const AreaUrl = '/lookup/ref/country?lookupcategory=area';
export const CurrencyUrl = '/lookup/ref/country?lookupcategory=currency';
export const UsageTypeUrl = '/lookup/ref?query=availability';
export const SpaceClassificationUrl = '/lookup/ref?query=space_classification';

export const FieldsLeaseSpace = [
  'spaceSize',
  'spaceSizeUOM',
  'suiteNumber',
  'leaseStartDate',
  'leaseEndDate',
  'spaceOccupancyDate',
  'spaceLeaseStatus',
  'floorNumber',
  'full_floor_f',
];

export const FieldsTenantSpace = [
  'suiteNumber',
  'spaceSize',
  'spaceSizeUOM',
  'leaseStartDate',
  'leaseEndDate',
  'rentRate',
  'rentRateUOM',
  'leaseStartDateEstF',
  'leaseEndDateEstF',
  'rentRateEstF',
  'floorNumber',
  'full_floor_f',
];

export const entityParamsOverlay = (
  data: AbstractSpaceClass,
  spaceSizeUOM: string,
  floorNumber: string,
  propertyId: number,
  propertyUsageId: number,
  floorId: number
) => {
  return {
    [EntitySPSpaces.Availability]: {
      availabilityId: data['id'],
      requestId: data['id'],
    },
    [EntitySPSpaces.AvailabilitySpace]: {
      availabilityId: data['id'],
      floorNo: floorNumber,
      propertyUsageId,
      propertyId,
      requestId: data['id'],
    },
    [EntitySPSpaces.Tenant]: {
      tenantId: data['tenantId'],
      requestId: data['tenantId'],
    },
    [EntitySPSpaces.TenantSpace]: {
      tenantId: data['tenantId'],
      spaceId: data['spaceId'],
      requestId: data['tenantId'],
    },
    [EntitySPSpaces.LeaseSpace]: {
      tenantId: data['tenantId'],
      propertyUsageId,
      propertyId,
      floorNumber,
      floorId,
      suiteId: data['suiteId'],
      suiteNumber: data['suiteNumber'],
      spaceSizeUOM: spaceSizeUOM,
    },
    [EntitySPSpaces.Lease]: {
      tenantId: data['tenantId'],
    },
  };
};
